// client/src/pages/MarketerRegisterPage.js
// 광고주 가입 — v5 리디자인: 유형 카드(1스텝) + 유형별 폼(2스텝)
// 유형 선택 시 초기화·폼 컴포넌트 4종·성공 모달 로직은 기존 그대로.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import MarketerRegistCorForm from '../components/MarketerRegistCorForm';
import MarketerRegistSoleForm from '../components/MarketerRegistSoleForm';
import MarketerRegistAgencyForm from '../components/MarketerRegistAgencyForm';
import MarketerRegistFreeForm from '../components/MarketerRegistFreeForm';
import '../styles/public/pub.css';

const TYPE_OPTIONS = [
  { key: 'corporate', icon: '🏢', label: '법인 사업자', desc: '법인 명의로 계약·세금계산서 발행' },
  { key: 'sole', icon: '🏪', label: '개인 사업자', desc: '개인 사업자등록증 보유' },
  { key: 'agency', icon: '🤝', label: '광고대행사', desc: '클라이언트를 대신해 운영' },
  { key: 'freelancer', icon: '💼', label: '프리랜서', desc: '사업자등록 없이 시작' },
];

const PASS_RE = /^[\]A-Za-z0-9~`!@#$%^&*()_\-+={}[|\\:;"'<>,.?/]{8,20}$/;

function MarketerRegisterPage() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const [emailVerified, setEmailVerified] = useState(false);
  const [idVerified, setIdVerified] = useState(false);
  const [requiredAgreed, setRequiredAgreed] = useState(false);

  const [formData, setFormData] = useState({
    userName: '',
    callNumber: '',
    email: '',
    userId: '',
    userPassword: '',
    marketingOption: false,
  });

  useEffect(() => {
    setFormData({
      userName: '',
      callNumber: '',
      email: '',
      userId: '',
      userPassword: '',
      marketingOption: false,
    });
    setEmailVerified(false);
    setIdVerified(false);
    setRequiredAgreed(false);
    setMessage('');
  }, [selectedType]);

  const commonFormProps = {
    formData,
    setFormData,
    emailVerified,
    setEmailVerified,
    idVerified,
    setIdVerified,
    requiredAgreed,
    setRequiredAgreed,
    loading,
    setLoading,
    setMessage,
    setIsSuccessModalOpen,
    passRe: PASS_RE,
  };

  const selectedLabel = TYPE_OPTIONS.find((t) => t.key === selectedType)?.label || '';

  return (
    <div className="pub">
      <Header />
      <main className="wrap wrap--narrow">
        <div className="pub-head">
          <h1>광고주 가입</h1>
          <p>사업자 유형을 고르면 유형에 맞는 정보만 물어봐요.</p>
        </div>

        {/* 서버 에러 메시지 */}
        {message && <div className="note note--red" style={{ marginTop: 0, marginBottom: 14 }}>{message}</div>}

        {/* 1스텝: 유형 선택 */}
        <div className="card">
          <div className="reg-step"><i>1</i><b>사업자 유형 선택</b><span>1 / 2</span></div>
          <div className="typegrid">
            {TYPE_OPTIONS.map((t) => (
              <button
                key={t.key}
                type="button"
                className={`typecard${selectedType === t.key ? ' is-active' : ''}`}
                onClick={() => setSelectedType(t.key)}
              >
                <i aria-hidden="true">{t.icon}</i>
                <b>{t.label}</b>
                <span>{t.desc}</span>
                {selectedType === t.key && <span className="badge badge--blue">선택됨</span>}
              </button>
            ))}
          </div>
          <div className="note note--blue">
            {selectedType ? '유형을 바꾸면 아래 입력 내용이 초기화돼요.' : '유형을 선택하면 가입 정보를 입력할 수 있어요.'}
          </div>
        </div>

        {/* 2스텝: 유형별 폼 */}
        {selectedType && (
          <div className="card">
            <div className="reg-step"><i>2</i><b>{selectedLabel} 정보</b><span>2 / 2</span></div>
            {selectedType === 'corporate' && <MarketerRegistCorForm {...commonFormProps} />}
            {selectedType === 'sole' && <MarketerRegistSoleForm {...commonFormProps} />}
            {selectedType === 'agency' && <MarketerRegistAgencyForm {...commonFormProps} />}
            {selectedType === 'freelancer' && <MarketerRegistFreeForm {...commonFormProps} />}
            <p className="hint" style={{ fontSize: 12, color: '#6b7686', marginTop: 10, textAlign: 'center' }}>
              사업자 확인은 보통 1영업일 안에 끝나요. 승인되면 메일로 알려드려요.
            </p>
          </div>
        )}
      </main>

      {/* 성공 모달 */}
      {isSuccessModalOpen && (
        <div className="pub-modal">
          <div className="pub-modal__box">
            <div style={{ width: 52, height: 52, borderRadius: '50%', background: '#eef3ff', color: '#1f4fd6', display: 'grid', placeItems: 'center', fontSize: 24, fontWeight: 800, margin: '0 auto 14px' }}>✓</div>
            <p style={{ fontWeight: 800, fontSize: 18, marginBottom: 8 }}>회원가입 완료</p>
            <p>회원가입이 완료되었습니다.</p>
            <button
              type="button"
              className="btn btn--blue btn--full"
              onClick={() => { setIsSuccessModalOpen(false); navigate('/'); }}
            >
              확인
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default MarketerRegisterPage;
